/**
 * Malosi AI — Shared core for header overlay + product embed
 * Singleton on window.MalosiAI
 */
(function () {
  'use strict';

  if (window.MalosiAI) return;

  var API_URL = 'https://lure-finder-api.malosi-studio.workers.dev';

  var STATUS_MESSAGES = [
    'Checking Jon\'s design notebooks',
    'Reviewing Niko\'s colour guides',
    'Flipping through studio lure files',
    'Checking the prototype shelf',
    'Reading Jon\'s field test notes',
    'Pulling specs from the workshop',
    'Matching lure weights to species',
    'Comparing swim actions',
    'Checking hook specs',
    'Cross-referencing rigging configs',
    'Scanning the Master range',
    'Looking through the Staples',
    'Checking Micro options',
    'Reviewing Marksman weights',
    'Pulling recommendations',
    'Checking water conditions',
    'Reviewing species profiles',
    'Matching tackle class'
  ];

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  // Sparkle SVG markup
  var SPARKLE_SVG = '<svg class="mai-sparkle-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 2L10.3 7.7L16 9L10.3 10.3L9 16L7.7 10.3L2 9L7.7 7.7L9 2Z" fill="currentColor"/><path d="M18 8L18.87 11.13L22 12L18.87 12.87L18 16L17.13 12.87L14 12L17.13 11.13L18 8Z" fill="currentColor" opacity="0.7"/><path d="M15 17L15.62 19.38L18 20L15.62 20.62L15 23L14.38 20.62L12 20L14.38 19.38L15 17Z" fill="currentColor" opacity="0.5"/></svg>';

  // Arrow SVG for submit
  var ARROW_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

  /**
   * Start status animation in a container element.
   * Returns a stop function.
   */
  function startStatus(container) {
    var msgs = shuffle(STATUS_MESSAGES);
    var idx = 0;

    var el = document.createElement('div');
    el.className = 'mai-status';
    el.innerHTML = '<span class="mai-status-dot"></span><span class="mai-status-text"></span>';
    container.appendChild(el);

    var textEl = el.querySelector('.mai-status-text');
    textEl.textContent = msgs[idx];

    var interval = setInterval(function () {
      idx = (idx + 1) % msgs.length;
      textEl.textContent = msgs[idx];
    }, 2200);

    return function stop() {
      clearInterval(interval);
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }

  /**
   * Call the AI API.
   * @param {string} query
   * @param {function} onSuccess - receives {message, products}
   * @param {function} onError - receives error string
   */
  function askAI(query, onSuccess, onError) {
    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('API ' + r.status);
      return r.json();
    })
    .then(function (data) {
      if (data.error) {
        onError(data.error);
      } else {
        onSuccess({
          message: data.message || '',
          products: data.products || []
        });
      }
    })
    .catch(function (err) {
      onError('Something went wrong. Please try again.');
      console.error('[MalosiAI]', err);
    });
  }

  /**
   * Render a text response into a container.
   */
  function renderResponse(container, query, message) {
    container.innerHTML = '';

    if (query) {
      var echo = document.createElement('p');
      echo.className = 'mai-query-echo';
      echo.textContent = 'You asked: ' + query;
      container.appendChild(echo);
    }

    var resp = document.createElement('div');
    resp.className = 'mai-response';
    // Convert newlines to paragraphs
    var lines = message.split('\n').filter(function (l) { return l.trim(); });
    resp.innerHTML = lines.map(function (l) { return '<p>' + esc(l) + '</p>'; }).join('');
    container.appendChild(resp);
  }

  function renderError(container, msg) {
    container.innerHTML = '';
    var el = document.createElement('p');
    el.className = 'mai-error';
    el.textContent = msg;
    container.appendChild(el);
  }

  // ── Typewriter ──────────────────────────────────────────────
  var TYPEWRITER_PROMPTS = [
    'GT off the reef, topwater',
    'beginner flathead in the estuary',
    'best lure for kingfish',
    'I\'m new to lure fishing',
    'dirty water bream lures',
    'heavy tackle GT setup',
    'best walking pencil for mangroves',
    'what hooks are on the Tyrant?',
    'light tackle tailor from the beach',
    'what\'s a good metal for mackerel?',
    'medium tackle kingfish from the rocks',
    'what colour for clear water?',
    'best lure under $30',
    'snapper from the rocks',
    'whiting in the estuary',
    'barramundi lures',
    'mulloway off the beach'
  ];

  /**
   * Start typewriter effect — replicates the lure-finder behaviour exactly.
   * @param {HTMLElement} inputEl - the text input
   * @param {HTMLElement} typewriterEl - the .mai-typewriter span
   * @param {HTMLElement} cursorEl - the .mai-cursor span (optional)
   * @returns {function} stop - call to kill the effect
   */
  function startTypewriter(inputEl, typewriterEl, cursorEl) {
    var gen = {};
    var currentGen = gen;
    var twInterval = null;
    var twTimeout = null;

    var prompts = shuffle(TYPEWRITER_PROMPTS);
    var pIdx = 0;

    // Measure span for auto-sizing input
    var measureSpan = document.createElement('span');
    measureSpan.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;pointer-events:none;';
    document.body.appendChild(measureSpan);

    function syncMeasureFont() {
      var cs = window.getComputedStyle(inputEl);
      measureSpan.style.fontFamily = cs.fontFamily;
      measureSpan.style.fontSize = cs.fontSize;
      measureSpan.style.fontWeight = cs.fontWeight;
      measureSpan.style.letterSpacing = cs.letterSpacing;
    }

    function autoSize() {
      syncMeasureFont();
      measureSpan.textContent = inputEl.value || '';
      inputEl.style.width = Math.max(Math.ceil(measureSpan.offsetWidth), 2) + 'px';
    }

    function typeNext() {
      if (gen !== currentGen) return;
      var text = prompts[pIdx % prompts.length];
      pIdx++;
      var charIdx = 0;
      typewriterEl.textContent = '';

      twInterval = setInterval(function () {
        if (gen !== currentGen) { clearInterval(twInterval); return; }
        charIdx++;
        typewriterEl.textContent = text.substring(0, charIdx);
        if (charIdx >= text.length) {
          clearInterval(twInterval);
          twTimeout = setTimeout(function () {
            if (gen !== currentGen) return;
            var eraseIdx = text.length;
            twInterval = setInterval(function () {
              if (gen !== currentGen) { clearInterval(twInterval); return; }
              eraseIdx--;
              typewriterEl.textContent = text.substring(0, eraseIdx);
              if (eraseIdx <= 0) {
                clearInterval(twInterval);
                twTimeout = setTimeout(typeNext, 400);
              }
            }, 30);
          }, 2500);
        }
      }, 60);
    }

    typeNext();

    function stopTw() {
      if (twInterval) { clearInterval(twInterval); twInterval = null; }
      if (twTimeout) { clearTimeout(twTimeout); twTimeout = null; }
      typewriterEl.textContent = '';
    }

    function onInput() {
      autoSize();
      if (inputEl.value.length > 0) stopTw();
    }

    function onFocus() {
      stopTw();
    }

    function onBlur() {
      if (!inputEl.value) {
        inputEl.style.width = '2px';
        pIdx = 0;
        prompts = shuffle(TYPEWRITER_PROMPTS);
        typeNext();
      }
    }

    // Click anywhere in input line focuses input
    var inputLine = inputEl.closest('.mai-input-line');
    function onLineClick(e) {
      if (!e.target.closest('button')) inputEl.focus();
    }

    inputEl.addEventListener('input', onInput);
    inputEl.addEventListener('focus', onFocus);
    inputEl.addEventListener('blur', onBlur);
    if (inputLine) inputLine.addEventListener('click', onLineClick);

    return function stop() {
      currentGen = {};
      stopTw();
      inputEl.removeEventListener('input', onInput);
      inputEl.removeEventListener('focus', onFocus);
      inputEl.removeEventListener('blur', onBlur);
      if (inputLine) inputLine.removeEventListener('click', onLineClick);
      if (measureSpan.parentNode) measureSpan.parentNode.removeChild(measureSpan);
    };
  }

  window.MalosiAI = {
    SPARKLE_SVG: SPARKLE_SVG,
    ARROW_SVG: ARROW_SVG,
    askAI: askAI,
    startStatus: startStatus,
    startTypewriter: startTypewriter,
    renderResponse: renderResponse,
    renderError: renderError,
    esc: esc
  };
})();
